export default __webpack_public_path__ + "static/ph_pool_kids-92e104c0a53dc1b071c65fd1261efd0e.jpeg";